import { ModelBase } from './model';

class Execution extends ModelBase {
  static namespace = 'reports/execution';

  static cache = false;
}
export default Execution.register();
